<template>
  <div>
    <div
      v-for="commentItem in commentList"
      :key="commentItem.id"
      style="margin: 12px;border: 1px solid #e0e0e0;padding: 12px;"
    >
      <img style="float: left;width： 50px;height: 50px;border-radius: 50px;" :src="commentItem.headerImg" />
      <div style="margin-left: 62px;">
        <div
          style="font-size: 14px;font-style: initial;line-height: 30px;color: #222;"
        >{{ commentItem.leave_user }}</div>
        <div
          style="font-size: 12px;line-height: 16px;color: #777;line-height: 20px;"
        >{{ commentItem.leavetime }}</div>
        <div style="font-size: 18px;line-height: 20px;color: #444">{{ commentItem.leavecontent }}</div>
        <template v-if="commentItem.children && commentItem.children.length > 0">
          <div
            style="margin: 12px;padding: 12px;"
            v-for="ccItem in commentItem.children"
            :key="ccItem.key"
          >
            <img style="float: left;width： 40px;height: 40px;border-radius: 40px;" :src="kerunHeader" />
            <div style="margin-left: 52px;">
              <div style="font-size: 12px;font-style: initial;line-height: 25px;color: #666">
                <span style="color: #444;font-size: 14px;">管理员</span>回复:
              </div>
              <div
                style="font-size: 12px;line-height: 15px;color: #999;"
              >{{ ccItem.replytime }}</div>
              <div style="font-size: 18px;line-height: 20px;color: #555">{{ ccItem.replycontent }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import v1 from '@/assets/imgs/v1.png'
import v2 from '@/assets/imgs/v2.png'
import v3 from '@/assets/imgs/v3.png'
import v4 from '@/assets/imgs/v4.png'
import kerunHeader from '@/assets/imgs/kerun-header.png'
export default {
  name: 'ArticleDetailCommentList',
  data () {
    return {
      kerunHeader: kerunHeader,
      headers: [{
        key: 'v1',
        img: v1
      }, {
        key: 'v2',
        img: v2
      }, {
        key: 'v3',
        img: v3
      }, {
        key: 'v4',
        img: v4
      }],
    }
  },
  props: {
    commentList: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>